export class EnvironmentService {
  constructor(
    readonly apiUrl: string,
    readonly devFeature: boolean,
  ) {}
}
